export const columns = [
    {
        title:'认购日期',
        dataIndex:"subscriptionTime",
        key:"subscriptionTime"
    },
    {
        title:'姓名/单位',
        dataIndex:"subscriptionName",
        key:"subscriptionName"
    },
    {
        title:'手机号',
        dataIndex:"phone",
        key:"phone"
    },
    {
        title:'认购数量(kg)',
        dataIndex:"subscriptionQuantity",
        key:"subscriptionQuantity"
    },
    {
        title:'认购金额(元)',
        dataIndex:"subscriptionAmount",
        key:"subscriptionAmount"
    },
    {
        title:'付款金额(元)',
        dataIndex:"payAmount",
        key:"payAmount"
    },
    {
        title:'林场名称',
        dataIndex:"policyTheme",
        key:"policyTheme"
    },
     {
        title:'支付状态',
        dataIndex:"payStatus",
        key:"payStatus",
        slots:'payStatus',
    },
    {
        title:'审核状态',
        dataIndex:"checkStatus",
        key:"checkStatus",
         slots:'checkStatus',
    },
    // {
    //     title:'政策内容',
    //     dataIndex:"policyContent",
    //     key:"policyContent"
    // },
    {
        title:'附件',
        dataIndex:"accessory",
        key:"accessory",
        slots:"accessory"
    },
    {
        title:'审核人',
        dataIndex:"chckerName",
        key:"chckerName"
    },
    {
        title:'审核时间',
        dataIndex:"chckerTime",
        key:"chckerTime"
    },
    {
        title:'备注',
        dataIndex:"remark",
        key:"remark"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]